// @ts-nocheck
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { CartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import EditFill from "@store/Components/Toolkit/Icons/Edit/EditFill";
import Eye from "@store/Components/Toolkit/Icons/Eye/EyeLine";
import EyeOff from "@store/Components/Toolkit/Icons/EyeOff/EyeOffLine";
import LogOut from "@store/Components/Toolkit/Icons/LogOut";
import PlusCircleFill from "@store/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import TrashFill from "@store/Components/Toolkit/Icons/Trash/TrashFill";
import { InfosBoxProps } from "@store/Components/Toolkit/InfosBox";
import { CheckboxPresentationProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import { FormFieldPresentationProps } from "@store/MobiusOverrides/FormField/FormField";
import { ProductAttributesStyles } from "@store/Overrides/Components/ProductAttributes";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import { ProductImageBadgesStyles } from "@store/Overrides/Components/ProductImageBadges";
import { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
import {
    priceSecondarySpacingStyles,
    priceStyles,
    priceUnitOfMeasureStyles,
    priceVatLabelStyles,
} from "@store/Themes/common/mixins/price";
import { inlineSeparatorStyles, typographyProductNameStyles } from "@store/Themes/common/mixins/typography";
import { attributeSpacing } from "@store/Themes/common/props/attributes";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import mergeProps from "@store/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@store/Framework/Common/Utilities/unitHelper";
import { gridGapStyles } from "@store/Themes/common/mixins/grid";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
import { css } from "styled-components";

/* Store Custom Code - Start */
import HeartPlus from "@store/Components/Toolkit/Icons/Heart/HeartPlus";
/* Store Custom Code - End */

export interface ProductLineProps {
    spacer?: InjectableCss;
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    messageInfosBox?: InfosBoxProps;
    sortSelectGridItem?: GridItemProps;
    selectedCheckbox?: CheckboxPresentationProps;
    imageGridItem?: GridItemProps;
    image?: ProductImageStyles;
    removeLink?: LinkPresentationProps;
    editNotesLink: LinkPresentationProps;
    addNotesLink: LinkPresentationProps;
    addToCartLink?: LinkPresentationProps;
    addToListLink?: LinkPresentationProps;
    leaveLink?: LinkPresentationProps;
    hideLink?: LinkPresentationProps;
    unhideLink?: LinkPresentationProps;
    viewReplacementLink?: LinkPresentationProps;
    contentGridItem?: GridItemProps;
    contentContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoContainer?: GridContainerProps;
    descriptionGridItem?: GridItemProps;
    brand?: ProductBrandStyles;
    description?: ProductDescriptionStyles;
    partNumbersGridItem?: GridItemProps;
    partNumbers?: ProductPartNumbersStyles;
    attributes?: ProductAttributesStyles;
    configurationGridItem?: GridItemProps;
    configuration?: TypographyProps;
    availabilityGridItem?: GridItemProps;
    availability?: ProductAvailabilityStyles;
    swatchGridItem?: GridItemProps;
    badgesGridItem?: GridItemProps;
    textBadges?: ProductTextBadgesStyles;
    imageBadges?: ProductImageBadgesStyles;
    deliveryScheduleGridItem?: GridItemProps;
    deliveryScheduleLink?: LinkPresentationProps;
    binInformationsGridItem?: GridItemProps;
    productBinNumbersContainer?: GridContainerProps;
    costCodeGridItem?: GridItemProps;
    costCodeLabel?: TypographyPresentationProps;
    costCodeSelect?: SelectPresentationProps;
    costCodeText?: TypographyPresentationProps;
    pricingGridItem?: GridItemProps;
    pricingContainer?: GridContainerProps;
    priceGridItem?: GridItemProps;
    price?: ProductPriceStyles;
    savedPrice?: {
        label?: TypographyPresentationProps;
        wrapper?: InjectableCss;
        unitOfMeasure?: TypographyPresentationProps;
        secondaryWrapper?: InjectableCss;
    };
    promotion?: TypographyProps;
    unitOfMeasureGridItem?: GridItemProps;
    unitOfMeasureContainer?: GridContainerProps;
    unitOfMeasureFieldGridItem?: GridItemProps;
    unitOfMeasureQuantityFieldGridItem?: GridItemProps;
    quantityGridItem?: GridItemProps;
    quantity?: CartLineQuantityStyles;
    subtotalGridItem?: GridItemProps;
    subtotalLabel?: TypographyPresentationProps;
    subtotalValue?: TypographyPresentationProps;
    subtotalSecondValue?: TypographyPresentationProps;
    subtotalVatLabel?: TypographyPresentationProps;
    notesWrapper?: InjectableCss;
    textField?: FormFieldPresentationProps<any>;
}

export const productLineContainerPadding = pxToRem(22, 0);

const descriptionTypographyProps: TypographyPresentationProps = {
    forwardAs: "h3",
    css: css`
        ${typographyProductNameStyles()}
    `,
};

const getLinkProps = (src?: IconPresentationProps["src"]) => {
    const spacing = pxToRem(6);

    return mergeProps<LinkPresentationProps>(linkGetActionLinkProps(src), {
        css: css`
            ${spacingStyles(spacing, spacing)}
            display: flex;
        `,
    });
};

const fullGridItemProps: GridItemProps = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

const subtotalValue: TypographyPresentationProps = {
    css: css`
        ${priceStyles()}
        font-weight: ${x => x.theme.design.typography.weight.bold};
    `,
};

const labelProps: TypographyPresentationProps = {
    variant: "legend",
    css: css`
        ${x => x.theme.typography.legend.css}
        display: block;
    `,
};

const formFieldProps: FormFieldPresentationProps<any> = {
    labelProps,
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            ${x => x.theme.formField.defaultProps?.cssOverrides?.formInputWrapper}
        `,
        inputSelect: css`
            ${x => x.theme.formField.defaultProps?.cssOverrides?.inputSelect}
        `,
    },
};

const borderWidth = pxToRem(1);

export const productLineProps: ProductLineProps = {
    spacer: {
        css: css`
            height: ${borderWidth};
        `,
    },
    container: {
        gap: 0,
        css: css`
            ${x => gridGapStyles(pxToRemArray([20]), [x.theme.design.typography.spacing.base])}
            position: relative;
            padding: ${productLineContainerPadding};
            border-top: ${borderWidth} solid ${getColor("common.border")};
            border-bottom: ${borderWidth} solid ${getColor("common.border")};
            word-break: break-word;
            background-color: ${getColor("common.background")};
            margin-top: -${borderWidth};

            &:first-child {
                padding-top: 0;
                border-top: 0;
                margin-top: 0;
            }

            &:last-child {
                padding-bottom: 0;
                border-bottom: 0;
            }
        `,
    },
    messageGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    messageInfosBox: {
        size: "small",
        type: "warning",
        extendedStyles: {
            wrapper: {
                css: spacingStyles(pxToRem(1), pxToRem(1)),
            },
        },
    },
    sortSelectGridItem: { width: 12 },
    selectedCheckbox: {
        sizeVariant: "small",
        css: css`
            ${x => x.theme.checkbox.defaultProps?.css as any}
            cursor: pointer;
            ${inlineSeparatorStyles({ spacing: pxToRem(23) })}

            @media print {
                display: none;
            }
        `,
    },
    imageGridItem: {
        width: [4, 3, 3, 2, 2],
        printWidth: 2,
        css: css`
            display: block;
        `,
    },
    image: {
        linkWrappingImage: {
            css: css`
                max-height: ${pxToRem(100)};
            `,
        },
        wrapper: {
            css: spacingStyles(null, pxToRem(12)),
        },
    },
    addToCartLink: getLinkProps(PlusCircleFill),
    removeLink: getLinkProps(TrashFill),
    addToListLink: getLinkProps(HeartPlus), // Store Custom Code
    leaveLink: getLinkProps(LogOut),
    hideLink: getLinkProps(EyeOff),
    unhideLink: getLinkProps(Eye),
    editNotesLink: getLinkProps(EditFill),
    addNotesLink: getLinkProps(EditFill),
    viewReplacementLink: getLinkProps(),
    contentGridItem: {
        width: [8, 9, 9, 10, 10],
        printWidth: 10,
        css: css`
            flex-direction: column;
        `,
    },
    contentContainer: {
        gap: 0,
        css: css`
            ${gridGapStyles(pxToRemArray([16]), pxToRemArray([10]))}
        `,
    },
    infoGridItem: {
        width: [12, 12, 12, 12, 6],
        printWidth: 6,
    },
    infoContainer: {
        gap: 0,
        css: css`
            ${gridGapStyles([], pxToRemArray([8]))}
        `,
    },
    descriptionGridItem: fullGridItemProps,
    brand: {
        wrapper: {
            css: css`
                ${spacingStyles(null, pxToRem(4)) /* Store Custom Code */}
            `,
        },
        /* Store Custom Code - Start */
        nameText: {
            color: "text.main",
            css: css`
                font-size: ${x => x.theme.design.typography.size.smallest};
                font-weight: ${x => x.theme.design.typography.weight.base};
                text-transform: uppercase;
            `,
        },
        /* Store Custom Code - End */
    },
    description: {
        productDetailLink: {
            typographyProps: descriptionTypographyProps,
        },
        productDetailDescription: descriptionTypographyProps,
    },
    partNumbersGridItem: {
        ...fullGridItemProps,
        css: css`
            ${fullGridItemProps.css}
            &&:not(:first-child) {
                margin-top: -${pxToRem(2)};
            }
        `,
    },
    partNumbers: {
        /* Store Removed - wrapper */
    },
    attributes: {
        container: {
            css: spacingStyles(null, attributeSpacing),
        },
    },
    configurationGridItem: fullGridItemProps,
    configuration: {
        color: "text.accent",
        forwardAs: "p",
        css: css`
            ${spacingStyles(null, pxToRem(3))}
            font-size: ${x => x.theme.design.typography.size.smaller};
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    availabilityGridItem: fullGridItemProps,
    availability: {
        inventoryMessage: {
            css: css`
                margin: ${pxToRem(3, 0) /* Store Custom Code */};
            `,
        },
    },
    swatchGridItem: fullGridItemProps,
    badgesGridItem: {
        width: [12, 12, 12, 8, 12],
        css: fullGridItemProps.css,
    },
    textBadges: {
        tagWrapper: {
            extendedStyles: {
                wrapper: {
                    css: css`
                        padding: ${pxToRem(2, 0)};
                    `,
                },
            },
        },
    },
    imageBadges: {},
    deliveryScheduleGridItem: fullGridItemProps,
    deliveryScheduleLink: {},
    binInformationsGridItem: fullGridItemProps,
    productBinNumbersContainer: {
        gap: 0,
        css: css`
            ${gridGapStyles([pxToRem(16)], [pxToRem(8)])}
        `,
    },
    costCodeGridItem: fullGridItemProps,
    costCodeLabel: labelProps,
    costCodeSelect: formFieldProps,
    costCodeText: {
        css: css`
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    pricingGridItem: {
        width: [12, 12, 12, 12, 6],
        printWidth: 6,
    },
    pricingContainer: {
        gap: 0,
        css: css`
            ${gridGapStyles([pxToRem(16)], [pxToRem(8)])}
        `,
    },
    priceGridItem: {
        width: [12, 5, 5, 5, 5],
        printWidth: 5,
        css: css`
            flex-direction: column;
        `,
    },
    price: {
        priceLabelText: labelProps,
        wrapper: {
            css: css`
                font-weight: ${x => x.theme.design.typography.weight.base};
            `,
        },
        price: {
            saleLabelText: {
                css: css`
                    display: block;
                    font-size: ${x => x.theme.design.typography.size.smaller};
                `,
            },
        },
    },
    savedPrice: {
        label: labelProps,
        wrapper: {
            css: priceStyles(),
        },
        secondaryWrapper: {
            css: css`
                ${priceStyles()}
                ${priceSecondarySpacingStyles()}
            `,
        },
        unitOfMeasure: {
            css: priceUnitOfMeasureStyles(),
        },
    },
    promotion: {
        italic: true,
        color: "text.accent",
        forwardAs: "p",
        css: css`
            font-size: ${x => x.theme.design.typography.size.tiny};
            line-height: ${x => x.theme.design.typography.lineHeight.small};
            ${spacingStyles(null, pxToRem(3))}
        `,
    },
    unitOfMeasureGridItem: { width: [12, 7, 7, 7, 7], printWidth: 7 },
    unitOfMeasureContainer: { gap: 10 },
    unitOfMeasureFieldGridItem: { width: [12, 8, 8, 8, 8], printWidth: 6 },
    unitOfMeasureQuantityFieldGridItem: {
        width: [12, 4, 4, 4, 4],
        printWidth: 6,
        css: css`
            flex-direction: column;
        `,
    },
    quantityGridItem: {
        width: [4, 3, 3, 3, 3],
    },
    quantity: {
        editableQuantityTextField: mergeProps<CartLineQuantityStyles["editableQuantityTextField"]>(formFieldProps, {
            cssOverrides: {
                inputSelect: css`
                    width: ${pxToRem(65)}; /* Store Custom Code */
                `,
                /* Store Custom Code - Start */
                descriptionWrapper: css`
                    ${x => x.theme.formField.defaultProps?.cssOverrides?.descriptionWrapper}
                    display: none;
                `,
                formField: css`
                    ${x => x.theme.formField.defaultProps?.cssOverrides?.formField}
                    width: auto;
                `,
                /* Store Custom Code - End */
            },
            /* Store Custom Code - Start */
            labelProps: {
                css: css`
                    position: relative;
                `,
            },
            /* Store Custom Code - End */
        }),
    },
    subtotalGridItem: {
        width: [8, 4, 4, 4, 4],
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    subtotalLabel: labelProps,
    subtotalValue,
    subtotalSecondValue: {
        ...subtotalValue,
        css: css`
            ${subtotalValue?.css}
            ${priceSecondarySpacingStyles()}
        `,
    },
    subtotalVatLabel: {
        css: priceVatLabelStyles(),
    },
    notesWrapper: {
        css: css`
            width: 100%;
            ${spacingStyles(pxToRem(12), null)}
        `,
    },
    textField: formFieldProps,
};
